import { DRG001Params } from "../api-service/parameters/DRG001Params";
import { DRG002Params } from "../api-service/parameters/DRG002Params";
import { HST001Params } from "../api-service/parameters/HST001Params";
import { LAB001Params } from "../api-service/parameters/LAB001Params";
import { OPD001Params } from "../api-service/parameters/OPD001Params";
import { OPD002Params } from "../api-service/parameters/OPD002Params";
import { PAT001Params } from "../api-service/parameters/PAT001Params";
import { PAY001Params } from "../api-service/parameters/PAY001Params";
import { PRN001Params } from "../api-service/parameters/PRN001Params";
import { PRN002Params } from "../api-service/parameters/PRN002Params";
import { PRN003Params } from "../api-service/parameters/PRN003Params";
import { REG001Params } from "../api-service/parameters/REG001Params";
import { REG002Params } from "../api-service/parameters/REG002Params";
import { SCH001Params } from "../api-service/parameters/SCH001Params";
import { STK001Params } from "../api-service/parameters/STK001Params";
import { SYS101Params } from "../api-service/parameters/SYS101Params";
import { NIS001Params } from "../api-service/parameters/NIS001Params";
import { SCS001Params } from "../api-service/parameters/SCS001Params";
import { CPH001Params } from "../api-service/parameters/CPH001Params";
import { OCS001Params } from "../api-service/parameters/OCS001Params";
import { SYS102Params } from "../api-service/parameters/SYS102Params";
import { ASD001Params } from "../api-service/parameters/ASD001Params";
import { CHI001Params } from "../api-service/parameters/CHI001Params";
import { PHR001Params } from "../api-service/parameters/PHR001Params";
import { HST002Params } from "../api-service/parameters/HST002Params";
import { SMS001Params } from '../api-service/parameters/SMS001Params';
import { OFF001Params } from '../api-service/parameters/OFF001Params';

export enum ParamGroupEnum {
  /** 病患參數 */
  PAT001 = 1001,
  /** 掛號參數*/
  REG001 = 2001,
  REG002 = 2002,
  /** 排班參數 */
  SCH001 = 2100,

  /**藥品設定參數 */
  DRG001 = 3001,
  /** 處方參數 */
  DRG002 = 3002,
  /** 藥局參數 */
  PHR001 = 3101,

  /**門診醫令參數 */
  HST001 = 4001,
  /** 選盤參數 */
  HST002 = 4002,
  CHI001 = 4101,
  /**支付參數 */
  PAY001 = 5001,

  /**檢驗參數 */
  LAB001 = 6001,

  /** 庫存參數 */
  STK001 = 7001,

  /**診斷參數 */

  OPD002 = 8001,

  /**健保相關參數 */
  OPD001 = 8002,
  /**列印參數 */
  PRN001 = 8101,
  /**列印參數 */
  PRN002 = 8102,
  /** 藥袋參數 */
  PRN003 = 8103,
  /** 預防接種參數 */
  NIS001 = 8301,
  /** 戒菸服務參數 */
  SCS001 = 8401,
  /** 兒童預防保健參數 Child Preventive Health Care */
  CPH001 = 8501,
  /** 口腔癌篩檢 Oral Cancer Screening */
  OCS001 = 8601,
  
  /** 中研院疾病監測參數*/
  ASD001 = 8701,
  /**系統參數 */
  SYS101 = 9101,
  /**系統UI參數 */
  SYS102 = 9102,
  SMS001 = 9201,
  /** 離線列印參數 */
  OFF001 = 8801,
}

export type ParamType = keyof typeof ParamGroupEnum;
export type ParamObjType = ParamMap[keyof ParamMap]
export type ParamMapKey = keyof ParamMap;
export interface ParamMap {
  PAT001: PAT001Params;
  REG001: REG001Params;
  REG002: REG002Params;
  PAY001: PAY001Params;
  OPD001: OPD001Params;
  OPD002: OPD002Params;
  HST001: HST001Params;
  HST002: HST002Params;
  DRG001: DRG001Params;
  DRG002: DRG002Params;
  SCH001: SCH001Params;
  SYS101: SYS101Params;
  PRN001: PRN001Params;
  PRN002: PRN002Params;
  PRN003: PRN003Params;
  LAB001: LAB001Params;
  STK001: STK001Params;
  NIS001: NIS001Params;
  SCS001: SCS001Params;
  CPH001: CPH001Params;
  ASD001 : ASD001Params
  OCS001: OCS001Params;
  SYS102: SYS102Params;
  CHI001: CHI001Params;
  PHR001: PHR001Params;
  SMS001:SMS001Params;
  OFF001: OFF001Params;
}

// 定義一個映射關係，從數值映射到字符串鍵
export const ParamGroupEnumKeyMap: { [key in ParamGroupEnum]: keyof ParamMap } = {
  [ParamGroupEnum.PAT001]: 'PAT001',
  [ParamGroupEnum.REG001]: 'REG001',
  [ParamGroupEnum.REG002]: 'REG002',
  [ParamGroupEnum.SCH001]: 'SCH001',
  [ParamGroupEnum.DRG001]: 'DRG001',
  [ParamGroupEnum.DRG002]: 'DRG002',
  [ParamGroupEnum.HST001]: 'HST001',
  [ParamGroupEnum.HST002]: 'HST002',
  [ParamGroupEnum.PAY001]: 'PAY001',
  [ParamGroupEnum.LAB001]: 'LAB001',
  [ParamGroupEnum.STK001]: 'STK001',
  [ParamGroupEnum.OPD001]: 'OPD001',
  [ParamGroupEnum.OPD002]: 'OPD002',
  [ParamGroupEnum.PRN001]: 'PRN001',
  [ParamGroupEnum.PRN002]: 'PRN002',
  [ParamGroupEnum.PRN003]: 'PRN003',
  [ParamGroupEnum.SYS101]: 'SYS101',
  [ParamGroupEnum.NIS001]: 'NIS001',
  [ParamGroupEnum.SCS001]: 'SCS001',
  [ParamGroupEnum.CPH001]: 'CPH001',
  [ParamGroupEnum.OCS001]: 'OCS001',
  [ParamGroupEnum.SYS102]: 'SYS102',
  [ParamGroupEnum.ASD001]: 'ASD001',
  [ParamGroupEnum.CHI001]: 'CHI001',
  [ParamGroupEnum.PHR001]: 'PHR001',
  [ParamGroupEnum.SMS001]: 'SMS001',
  [ParamGroupEnum.OFF001]: 'OFF001',
};
